import { z } from 'zod';

import { PolicyKind, PolicyStatus } from '@nucleus-commerce/api-client/admin';

import { seoOverrideSchema } from '@/features/seo';

const HANDLE = /^[a-z0-9](?:[a-z0-9-]*[a-z0-9])?$/;

export const POLICY_SUMMARY_MAX = 500;

export const policyFormSchema = z.object({
  kind: z.enum(PolicyKind),
  title: z
    .string()
    .trim()
    .min(1, { error: 'policies:validation.titleRequired' })
    .max(160, { error: 'policies:validation.titleLength' }),
  handle: z
    .string()
    .trim()
    .min(1, { error: 'policies:validation.handleRequired' })
    .max(120, { error: 'policies:validation.handleLength' })
    .regex(HANDLE, { error: 'policies:validation.handleFormat' }),
  summary: z
    .string()
    .trim()
    .max(POLICY_SUMMARY_MAX, { error: 'policies:validation.summaryLength' }),
  bodyHtml: z.string().max(200_000, { error: 'policies:validation.bodyLength' }),
  status: z.enum(PolicyStatus),
  seo: seoOverrideSchema,
});

export type PolicyFormInput = z.input<typeof policyFormSchema>;
export type PolicyFormValues = z.output<typeof policyFormSchema>;
